/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-26 15:09:16
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-05-10 17:13:28
 */
import {
	DEPT_DATA_SCOPE_PERSONAL,
	DEPT_DATA_SCOPE_ALL,
	DEPT_DATA_SCOPE_DEPT,
	DEPT_DATA_SCOPE_DEPTS,
	drRoleType,
	zsRoleType,
	DATAVIEW_ANCHOR_PARTNER_TAG,
	DATAVIEW_SHOP_PARTNER_TAG,
	DATAVIEW_ALL_DEPT,
	DATAVIEW_NO_TAG,
} from '@/utils/dataMap';
export default {
	// 全部数据权限
	isAllDataScope(state) {
		return state.vuex_permissionInfo?.user?.dateScope == DEPT_DATA_SCOPE_ALL;
	},
	// 具有部门权限筛选//本部门
	hasDeptDataScope(state) {
		return [DEPT_DATA_SCOPE_ALL, DEPT_DATA_SCOPE_DEPT, DEPT_DATA_SCOPE_DEPTS].includes(+state.vuex_permissionInfo?.user?.dateScope);
	},
	// 是否展示部门下拉筛选项//本部门及以下
	showDeptSelect(state) {
		return [DEPT_DATA_SCOPE_ALL, DEPT_DATA_SCOPE_DEPTS].includes(+state.vuex_permissionInfo?.user?.dateScope);
	},
	// 仅本人数据权限
	isPersonDataScope(state) {
		return +state.vuex_permissionInfo?.user?.dateScope === DEPT_DATA_SCOPE_PERSONAL;
	},
	// 当前数据视角为达人运营
	isDrPartnerDataView(state) {
		return +state.vuex_dataViewId === DATAVIEW_ANCHOR_PARTNER_TAG;
	},
	// 当前数据视角为店铺运营
	isShopPartnerDataView(state) {
		return +state.vuex_dataViewId === DATAVIEW_SHOP_PARTNER_TAG;
	},
	// 当前数据视角为全部数据
	isAllDataView(state) {
		return +state.vuex_dataViewId === DATAVIEW_ALL_DEPT;
	},
	// 当前数据视角不是达人运营或店铺运营
	isNotShopOrDrDataView(state) {
		return [DATAVIEW_ALL_DEPT, DATAVIEW_NO_TAG].includes(+state.vuex_dataViewId);
	},
	// 拥有达人运营标签
	hasDrPartnerTag(state) {
		return state.vuex_permissionInfo?.user?.userTypes?.some(item => [drRoleType.id].includes(item.type));
	},
	// 拥有店铺运营
	hasZsPartnerTag(state) {
		return state.vuex_permissionInfo?.user?.userTypes?.some(item => [zsRoleType.id].includes(item.type));
	},
	// 仅是店铺运营
	onlyZsPartnerTag(state) {
		return state.vuex_permissionInfo?.user?.userTypes.length === 1 && state.vuex_permissionInfo?.user?.userTypes[0]?.type === zsRoleType.id;
	},
	// 仅是达人运营
	onlyPartnerTag(state) {
		return state.vuex_permissionInfo?.user?.userTypes.length === 1 && state.vuex_permissionInfo?.user?.userTypes[0]?.type === drRoleType.id;
	},
	// 包含达人运营标签且本人数据权限
	hasDrPartnerTagAndSelfDataScope(state) {
		return (
			+state.vuex_permissionInfo?.user?.dateScope === DEPT_DATA_SCOPE_PERSONAL &&
			state.vuex_permissionInfo?.user?.userTypes?.some(item => [drRoleType.id].includes(item.type))
		);
	},
	// 无用户标签
	hasUserTag(state) {
		return !state.vuex_permissionInfo?.user?.userTypes?.some(item => [drRoleType.id, zsRoleType.id].includes(item.type));
	},
};
